import React from 'react';

const Filter = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.09581 7.56062C6.26371 7.74334 6.3559 7.98203 6.3559 8.22895V15.5048C6.3559 15.9427 6.8843 16.1649 7.19706 15.8571L9.22672 13.5311C9.49833 13.2052 9.64813 13.0438 9.64813 12.7212V8.23059C9.64813 7.98367 9.74195 7.74499 9.90821 7.56225L15.7321 1.24282C16.1684 0.768737 15.8326 0 15.1873 0H0.816706C0.171429 0 -0.166024 0.767091 0.271842 1.24282L6.09581 7.56062Z" />
  </svg>
);

export default Filter;
